module.exports = __webpack_public_path__ + "img/yj_single_coupon_bg.d4ad737f.png";